import {Color} from "../stores/dataSources/UsersDataSource";
import {ClientUser, Workspace} from "../API";


export function getColor(data: ClientUser | Workspace): Color {
    if ("email" in data) {
        return stringToColor(data.email);
    } else if ("slug" in data) {
        return stringToColor(data.slug);
    }
    return stringToColor('gray')
}

export function stringToColor(string?: string | null): Color {
    if (!string) {
        return {hue: 0, saturation: 0, lightness: 50};
    }

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // force 32bit integer
    }

    // Use different bit sections to randomize more
    const hue = (hash & 0xfff) % 360;        // low bits
    const saturation = 70 + ((hash >> 12) & 0x1f) % 10; // mid bits
    const lightness = 30 + ((hash >> 24) & 0x3f) % 10;  // high bits

    return {hue, saturation, lightness};
}
